// Utils
import { isDebugEnabled } from '../../debug/debugUtil';

// Selectors
import { getGridSizeName } from './gridSizeSelector';

// Actions
import { updatePlatformDetails } from '../../platform/platformActions';

// Constants
import { GRID_RESIZE, GRID } from './gridConstants';
import { MilanoteApplicationMode } from '../../../common/platform/platformTypes';

export const setGridSize = (gridSize, sizeName) => ({ type: GRID_RESIZE, gridSize, sizeName });

const getSmallerGridSize = (sizeName) => {
    switch (sizeName) {
        case GRID.LARGE.name:
            return GRID.MEDIUM;
        case GRID.MEDIUM.name:
            return GRID.SMALL;
        case GRID.SMALL.name:
        case GRID.MOBILE.name:
        default:
            // only allow developers to access the mobile app size via keyboard shortcut
            return isDebugEnabled() ? GRID.MOBILE : GRID.SMALL;
    }
};

const getLargerGridSize = (sizeName) => {
    switch (sizeName) {
        case GRID.MOBILE.name:
            return GRID.SMALL;
        case GRID.SMALL.name:
            return GRID.MEDIUM;
        case GRID.MEDIUM.name:
        case GRID.LARGE.name:
        default:
            return GRID.LARGE;
    }
};

export const decreaseGridSize = () => (dispatch, getState) => {
    const state = getState();
    const { size, name } = getSmallerGridSize(getGridSizeName(state));

    dispatch(setGridSize(size, name));

    if (name === GRID.MOBILE.name) {
        dispatch(updatePlatformDetails({ appMode: MilanoteApplicationMode.mobile }));
    }
};

export const increaseGridSize = () => (dispatch, getState) => {
    const { size, name } = getLargerGridSize(getGridSizeName(getState()));
    dispatch(setGridSize(size, name));

    // FIXME-MOBILE - Remove this when we remove the GRID.MOBILE
    if (name === GRID.SMALL.name) {
        dispatch(updatePlatformDetails({ appMode: MilanoteApplicationMode.desktop }));
    }
};

/**
 * Sets the application mode to desktop. GridSizeManager derives the matching grid: the stored desktop
 * preference, or the large grid when there is none.
 */
export const switchToDesktopMode = () => (dispatch) => {
    dispatch(updatePlatformDetails({ appMode: MilanoteApplicationMode.desktop }));
};

/**
 * Sets the application mode to mobile. GridSizeManager derives the matching grid, the mobile grid.
 */
export const switchToMobileMode = () => (dispatch) => {
    dispatch(updatePlatformDetails({ appMode: MilanoteApplicationMode.mobile }));
};
